import {
  TrackPick,
  picksSequenceHasBans,
  trackWasBanned,
  picksSequenceHasPicks,
  trackWasPicked,
  getPickPosition,
  trackPickedWhenAvailable,
} from "model/Match/TrackPick";
import { nonUndefined } from "Utility";

export const AVERAGE_PICK_POSITION_HEADER = "AP";
export const BANS_HEADER = "Bans";
export const PICKED_WHEN_AVAILABLE_HEADER = "PWA";
export const PICKS_HEADER = "Picks";
export const WINNER_PICKED_HEADER = "WP";
export const WON_WHEN_PICKED_HEADER = "WP";

export const AVERAGE_PICK_POSITION_TITLE =
  "Average Pick Position - Average Position Of Pick When Picked ";
export const BANS_TITLE =
  "Bans - Number Of Times Track Banned / Number Of Pick Ban Sequences";
export const PICKED_WHEN_AVAILABLE_TITLE =
  "Picked When Available - Pick Rate When The Track Wasn't Banned Before First Pick In The Pick Ban Sequence";
export const PICKS_TITLE =
  "Picks - Number Of Times Track Picked / Number Of Pick Ban Sequences";
export const WINNER_PICKED_TITLE =
  "Winner Picked - How Often The Team That Picked The Track Won";
export const WON_WHEN_PICKED_TITLE =
  "Won When Picked - How Often The Team Picked The Track And Won";

export const statTrackPicksBanRate = (
  pickSequences: TrackPick[][],
  trackId: string,
  rosterId?: string
) => {
  const pickSequencesWithTeamBans = pickSequences.filter((sequence) =>
    picksSequenceHasBans(sequence)
  );

  if (pickSequencesWithTeamBans.length === 0) {
    return { rate: undefined, breakdown: "0/0" };
  }

  const numberOfPickSequences = pickSequencesWithTeamBans.length;
  const numberOfTimesBanned = pickSequencesWithTeamBans.filter((seq) =>
    trackWasBanned(seq, trackId, rosterId)
  ).length;

  const rate = numberOfTimesBanned / numberOfPickSequences;
  const breakdown = `${numberOfTimesBanned}/${numberOfPickSequences}`;
  return { rate, breakdown };
};

export const statTrackPicksPickRate = (
  pickSequences: TrackPick[][],
  trackId: string,
  rosterId?: string
) => {
  const pickSequencesWithTeamPicks = pickSequences.filter((sequence) =>
    picksSequenceHasPicks(sequence)
  );

  if (pickSequencesWithTeamPicks.length === 0) {
    return { rate: undefined, breakdown: "0/0" };
  }

  const numberOfPickSequences = pickSequencesWithTeamPicks.length;
  const numberOfTimesPicked = pickSequencesWithTeamPicks.filter((seq) =>
    trackWasPicked(seq, trackId, rosterId)
  ).length;

  const rate = numberOfTimesPicked / numberOfPickSequences;
  const breakdown = `${numberOfTimesPicked}/${numberOfPickSequences}`;
  return { rate, breakdown };
};

export const statTrackPicksAveragePickPosition = (
  pickSequences: TrackPick[][],
  trackId: string
) => {
  const pickSequencesWithTrackPicked = pickSequences.filter((sequence) =>
    trackWasPicked(sequence, trackId)
  );

  if (pickSequencesWithTrackPicked.length === 0) {
    return undefined;
  }

  const pickPositions = pickSequencesWithTrackPicked
    .flatMap((seq) => getPickPosition(seq, trackId) ?? 0)
    .filter((pos) => pos > 0);
  const total = pickPositions.reduce((a, b) => a + b, 0);

  return total / pickPositions.length;
};

export const statTrackPicksPickedWhenAvailable = (
  pickSequences: TrackPick[][],
  trackId: string
) => {
  const pickSequencesWithTrackPicked = pickSequences.filter((sequence) =>
    picksSequenceHasPicks(sequence)
  );

  if (pickSequencesWithTrackPicked.length === 0) {
    return { rate: undefined, breakdown: "0/0" };
  }

  const whenAvailableWasPicked = nonUndefined(
    pickSequencesWithTrackPicked.flatMap((seq) =>
      trackPickedWhenAvailable(seq, trackId)
    )
  );

  const pickedCount = whenAvailableWasPicked.filter((p) => p === true).length;
  const availableCount = whenAvailableWasPicked.length;

  const rate = pickedCount / availableCount;
  const breakdown = `${pickedCount}/${availableCount}`;
  return { rate, breakdown };
};
